import React from 'react'

const Error = () => {
  return (
    <div className='text-3xl font-bold h-screen w-screen flex items-center justify-center'>Error 404!</div>
  )
}

export default Error